import { render, staticRenderFns } from "./PageOffers.vue?vue&type=template&id=5785e010&"
import script from "./PageOffers.vue?vue&type=script&lang=js&"
export * from "./PageOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports